import React from "react";
import { useEffect } from "react";

import { FaCheck } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import UserPlaceHolderImg from "../../assets/img/common/user-placeholder-img.png";
import { useDeleteUnregisteredInvitationMutation } from "../../redux/slices/api/projectsApiSlice";
import { handleError } from "../../hooks/useApi";
import { useSearchParams } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import useNavigateToProfile from "../../hooks/useNavigateToProfile";

const MemberItem = ({ user, formik, onChange, isCreator }) => {
  // Custom hook for navigating to user profiles.
  const { navigateToProfile } = useNavigateToProfile();

  // Custom mutation hook for deleting unregistered invitations.
  const [deleteInvitation, { isLoading: deleteInvitationLoading }] =
    useDeleteUnregisteredInvitationMutation();

  // Destructure collaborators-related values from the Formik values or set default values.
  const { collaborators, collaborators_queue, collaborators_email } =
    formik?.values ?? {};

  // Check if the user has accepted or requested collaboration.
  let accepted = !!collaborators?.find((item) => user?._id === item?._id);
  let requested =
    !!collaborators_queue?.find(
      (item) => user?._id === item?._id || user === item
    ) || !!collaborators_email?.find((item) => item === user);
  let checked = accepted || requested;

  // Get the project ID from the URL search parameters.
  const [searchParam, setSearchParam] = useSearchParams();
  let project_id = searchParam.get("edit");

  // Handle the removal of a collaborator.
  const handleRemove = () => {
    let updatedEmails = [...formik?.values?.collaborators_email];
    let updatedCollaboratorsQueue = [...formik?.values?.collaborators_queue];
    let updatedCollaborators = [...formik?.values?.collaborators];

    let foundEmailIndex = updatedEmails?.findIndex((item) => item === user);

    let foundCollaboratorsQueueIndex = updatedCollaboratorsQueue?.findIndex(
      (item) => item?._id === user?._id || item === user
    );
    let foundCollaboratorsIndex = updatedCollaborators?.findIndex(
      (item) => item?._id === user?._id || item === user
    );

    // If the project ID exists and the collaborator is unregistered, delete the invitation.
    if (
      project_id &&
      typeof updatedCollaboratorsQueue?.[foundCollaboratorsQueueIndex] ===
        "string"
    ) {
      deleteInvitation({
        body: {
          email: updatedCollaboratorsQueue?.[foundCollaboratorsQueueIndex],
        },
        id: project_id,
      })
        .unwrap()
        .then((res) => res)
        .catch((err) => handleError(err, null, true));
      return;
    }

    // Remove the collaborator from the respective arrays and update Formik values.
    if (foundCollaboratorsQueueIndex >= 0) {
      updatedCollaboratorsQueue?.splice(foundCollaboratorsQueueIndex, 1);
      formik?.setFieldValue("collaborators_queue", updatedCollaboratorsQueue);
    }
    if (foundEmailIndex >= 0) {
      updatedEmails.splice(foundEmailIndex, 1);
      formik?.setFieldValue("collaborators_email", updatedEmails);
    }
    if (foundCollaboratorsIndex >= 0) {
      updatedCollaborators.splice(foundCollaboratorsIndex, 1);
      formik?.setFieldValue("collaborators", updatedCollaborators);
    }
  };

  return (
    <div
      className={`w-full h-16 px-3 flex items-center hover:bg-slate-200  border-b border-custom-gray-300 group`}
    >
      <div className="w-full flex justify-between">
        <button
          type="button"
          onClick={() =>
            (user?.firstname || user?.fundername) &&
            navigateToProfile(user?._id, user?.role, true)
          }
          className="flex items-center"
        >
          <img
            src={user?.images?.profile || UserPlaceHolderImg}
            alt="user-img"
            className="w-9 h-9 rounded-full"
          />
          <div className=" flex flex-col items-start max-w-[90%] ml-3 ">
            <span className="font-bold text-sm text-secondary truncate">
              {typeof user === "object"
                ? `${
                    user?.fundername ?? `${user?.firstname} ${user?.lastname}`
                  }`
                : user}
            </span>
            {user?.email ? (
              <span className="mt-0.5 text-xs">{user?.email}</span>
            ) : (
              <span className="mt-0.5 text-xs text-yellow-700">
                {" "}
                un-registered
              </span>
            )}
          </div>{" "}
        </button>
        {!isCreator && (
          <div className="flex flex-col items-center">
            {checked ? (
              <span
                className={` ${
                  accepted
                    ? "bg-[#0fb263]"
                    : (requested || typeof user === "string") && "bg-[#e7d12e]"
                }  rounded-full h-4 w-4 flex justify-center items-center mb-0.5`}
              >
                <FaCheck color="white" className="text-[8px]" />
              </span>
            ) : null}
            {deleteInvitationLoading ? (
              <Oval
                height={14}
                width={14}
                color="#8538FF"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#8538FF"
                strokeWidth={2}
                strokeWidthSecondary={2}
              />
            ) : (
              <button
                type="button"
                onClick={handleRemove}
                className="hidden group-hover:flex mt-2 w-4 h-4"
              >
                <IoClose className="text-red-500 text-lg" />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MemberItem;
